import React from 'react'
import styled from 'styled-components'
import { ReactComponent as SadFace } from "../../Assets/iconsv2/generic/sadFace.svg";
import { useTranslate } from '@tolgee/react';
const EmptyContactsList = () => {
    const { t } = useTranslate();
    return (

        <EmptyCallListWrapper>
            <SadFace />
            <p>{t('contacts.contacts_empty_list')}</p>
        </EmptyCallListWrapper>

    )
}

export default EmptyContactsList

const EmptyCallListWrapper = styled.div`
display:flex;
flex-direction:column;
gap:8px;
align-items:center;
justify-content:center;
margin:auto;
color:${({ theme }) => theme.menu.secondaryTextColor};
`